import Kube from '@/assets/ico/kube.svg?c';

import { Widget, WidgetTitle, WidgetBody } from '@@/Widget';
import { DetailsTable } from '@@/DetailsTable';
import { Button } from '@@/buttons/Button';
import { ExternalLink } from '@@/ExternalLink';

import { CloudProviderSettings } from '../../types';

interface KaaSClusterDetailsWidgetProps {
  cloudProvider: Partial<CloudProviderSettings>;
}

export function KaaSClusterDetailsWidget({
  cloudProvider,
}: KaaSClusterDetailsWidgetProps) {
  const { Name, URL, Region, Size, NetworkID, NodeIPs } = cloudProvider;

  if (!Name || !URL) {
    return null;
  }

  return (
    <Widget>
      <WidgetTitle icon={Kube} title="KaaS cluster details" />
      <WidgetBody className="no-padding">
        <DetailsTable dataCy="kaas-cluster-details-table">
          <DetailsTable.Row label="Provider">
            {Name}
            <Button
              as={ExternalLink}
              props={{
                to: URL,
                showIcon: false,
              }}
              color="primary"
              size="xsmall"
              className="ml-1"
              data-cy="kaas-portal-link"
            >
              Go to portal
            </Button>
          </DetailsTable.Row>
          {!!Region && (
            <DetailsTable.Row label="Region">{Region}</DetailsTable.Row>
          )}
          {!!Size && (
            <DetailsTable.Row label="Node Size">{Size}</DetailsTable.Row>
          )}
          {!!NetworkID && (
            <DetailsTable.Row label="Network Id">{NetworkID}</DetailsTable.Row>
          )}
          {!!NodeIPs && (
            <DetailsTable.Row label="Node IPs">{NodeIPs}</DetailsTable.Row>
          )}
        </DetailsTable>
      </WidgetBody>
    </Widget>
  );
}
